import { render, staticRenderFns } from "./PromoCard.vue?vue&type=template&id=ae508e98&scoped=true&"
import script from "./PromoCard.vue?vue&type=script&lang=js&"
export * from "./PromoCard.vue?vue&type=script&lang=js&"
import style0 from "./PromoCard.vue?vue&type=style&index=0&id=ae508e98&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae508e98",
  null
  
)

export default component.exports